import { getFullImageUrl } from "../../utils/urlConfig";
import React from 'react';
import styles from './ImageModal.module.css';  // Import the CSS module

const ImageModal = ({ isOpen, images, currentImageIndex, onClose, onNext, onPrevious }) => {

    if (!isOpen || !images.length) return null;

    const currentImage = images[currentImageIndex];

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <button onClick={onClose} className={styles.closeButton}>🗙</button>

                <div className={styles.imageContainer}>
                    <img
                        src={getFullImageUrl(currentImage)}
                        alt="Large View"
                        className={styles.imageStyle}
                    />
                </div>

                <div className={styles.imageNavigation}>
                    <button onClick={onPrevious} className={styles.navButton}>Previous</button>
                    <button onClick={onNext} className={styles.navButton}>Next</button>
                </div>
            </div>
        </div>
    );
};

export default ImageModal;
